// Copyright 2026 FlairCV Contributors
// SPDX-License-Identifier: AGPL-3.0-or-later

import { forwardRef } from 'react';
import { cn } from '../lib/utils';

/**
 * Premium native Select with enhanced focus ring (ring-offset-2, primary ring),
 * subtle background tint on hover, and consistent styling with Input.
 *
 * For richer dropdowns, use Radix Select primitives.
 * Used identically across OSS and Enterprise editions.
 */
const Select = forwardRef<
  HTMLSelectElement,
  React.ComponentProps<'select'>
>(({ className, ...props }, ref) => {
  return (
    <select
      className={cn(
        'flex h-9 w-full rounded-lg border border-input bg-background px-3 py-2',
        'text-[14px] text-foreground',
        'ring-offset-background transition-colors duration-150',
        'hover:bg-accent/30',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Select.displayName = 'Select';

export { Select };
